module.exports = __webpack_public_path__ + "assets/certificate_pdf/Python Language Today_Silicon Stone Education_20180718.325739de.pdf";